module.exports = "/static/assets/26add8d06fefebf31d5525168e6e51f4.png";